export default __webpack_public_path__ + "static/media/teamRightarrow.0464d33c.svg";